import React from 'react'
import { CreateIndeedFlexCompanyFlowProvider } from './context/CreateIndeedFlexCompanyFlowProvider'
import { CreateIndeedFlexCompanyFlowMain } from './components/CreateIndeedFlexCompanyFlowMain'

export const CreateIndeedFlexCompanyFlow = () => {
  return (
    <CreateIndeedFlexCompanyFlowProvider>
      <CreateIndeedFlexCompanyFlowMain />
    </CreateIndeedFlexCompanyFlowProvider>
  )
}
